// The deal register's columns and URL state: what is shown, which columns sort, the default
// order, and the filter. The mechanics are ui/tableUrl.js, shared with every other table.

import { createTableUrl } from '../ui/tableUrl.js';

// In display order. A column without `sortable` is a plain header: the internal id, the trader
// and the direction are not sorts the API serves, and volume, price and value are deliberately
// unordered - MT and cubic metres have no common order, and neither have USD and KES.
export const COLUMNS = [
  { key: 'deal_number', label: 'Deal number', sortable: true, defaultDirection: 'asc' },
  { key: 'internal_id', label: 'Internal id' },
  { key: 'state', label: 'State', sortable: true, defaultDirection: 'asc' },
  { key: 'direction', label: 'Buy / sell' },
  { key: 'counterparty', label: 'Counterparty', sortable: true, defaultDirection: 'asc' },
  { key: 'product', label: 'Product', sortable: true, defaultDirection: 'asc' },
  { key: 'trader', label: 'Trader' },
  { key: 'volume', label: 'Volume' },
  { key: 'price', label: 'Price' },
  { key: 'value', label: 'Value' },
  { key: 'last_activity', label: 'Last activity', sortable: true, defaultDirection: 'desc' },
  { key: 'created', label: 'Created', sortable: true, defaultDirection: 'desc' },
];

export const SORTABLE_COLUMNS = COLUMNS.filter((column) => column.sortable);

// With the deal flow on (TX-US-0043), the stage takes the state's place: the register sorts it in
// flow order, the ends last.
const STAGE_COLUMN = { key: 'stage', label: 'Stage', sortable: true, defaultDirection: 'asc' };

export const FLOW_COLUMNS = COLUMNS.map((column) => (column.key === 'state' ? STAGE_COLUMN : column));

export const FLOW_SORTABLE_COLUMNS = FLOW_COLUMNS.filter((column) => column.sortable);

// The columns the register shows, by whether the flow is on.
export const columnsFor = (flow) => (flow ? FLOW_COLUMNS : COLUMNS);
export const sortableColumnsFor = (flow) => (flow ? FLOW_SORTABLE_COLUMNS : SORTABLE_COLUMNS);

export const {
  DEFAULT_QUERY,
  defaultDirectionFor,
  fromSearchParams,
  toQueryString,
  nextSort,
  withFilter,
  withCursor,
  toApiSearch,
} = createTableUrl({
  // Either set's sorts read from a URL: the register offers only its own set's, and the API
  // serves both.
  columns: [...SORTABLE_COLUMNS, STAGE_COLUMN],
  defaultSort: 'last_activity',
  // `waiting` is the flow's Waiting for me: the deals whose open approval step is the reader's.
  filters: ['counterparty', 'state', 'stage', 'waiting'],
});
